import { lastDayOfMonth, startOfMonth, subYears } from 'date-fns';

import { formatDate, isNotDefined } from '@hsp/utilities';

export const listPerformanceLoaderDefaults = (startDate?: string | null, endDate?: string | null) => {
  const date = new Date();
  const end = lastDayOfMonth(date);
  const start = subYears(startOfMonth(date), 2);

  return {
    endDate: isNotDefined(endDate) ? formatDate(end, 'yyyy-MM-dd') : endDate,
    startDate: isNotDefined(startDate) ? formatDate(start, 'yyyy-MM-dd') : startDate,
  };
};
